var map = {
	"./bg": 35,
	"./bg.jpg": 35,
	"./bgm": 36,
	"./bgm.jpg": 36,
	"./cells/cell-19": 37,
	"./cells/cell-19.png": 37,
	"./cells/cell-20": 38,
	"./cells/cell-20.png": 38,
	"./cells/cell-21": 39,
	"./cells/cell-21.png": 39,
	"./cells/cell-22": 40,
	"./cells/cell-22.png": 40,
	"./cells/cell-23": 41,
	"./cells/cell-23.png": 41,
	"./cells/cell-24": 42,
	"./cells/cell-24.png": 42,
	"./cells/cell-25": 43,
	"./cells/cell-25.png": 43,
	"./cells/cell-26": 44,
	"./cells/cell-26.png": 44,
	"./cells/cell-27": 45,
	"./cells/cell-27.png": 45,
	"./cells/cell-28": 46,
	"./cells/cell-28.png": 46,
	"./cells/cell-29": 47,
	"./cells/cell-29.png": 47,
	"./cells/cell-30": 48,
	"./cells/cell-30.png": 48,
	"./cells/cell-31": 49,
	"./cells/cell-31.png": 49,
	"./garland-1": 50,
	"./garland-1-1": 51,
	"./garland-1-1.png": 51,
	"./garland-1-2": 52,
	"./garland-1-2.png": 52,
	"./garland-1.png": 50,
	"./garland-2": 53,
	"./garland-2-1": 54,
	"./garland-2-1.png": 54,
	"./garland-2-2": 55,
	"./garland-2-2.png": 55,
	"./garland-2.png": 53,
	"./logo-1": 56,
	"./logo-1.png": 56,
	"./logo-2": 57,
	"./logo-2.png": 57,
	"./logo-3": 58,
	"./logo-3.png": 58,
	"./logo-4": 59,
	"./logo-4.png": 59,
	"./logo-5": 60,
	"./logo-5.png": 60,
	"./logom-1": 61,
	"./logom-1.png": 61,
	"./logom-2": 62,
	"./logom-2.png": 62,
	"./logom-3": 63,
	"./logom-3.png": 63,
	"./logom-4": 64,
	"./logom-4.png": 64,
	"./logom-5": 65,
	"./logom-5.png": 65,
	"./main-bg": 66,
	"./main-bg.jpg": 66,
	"./main-bgm": 67,
	"./main-bgm.jpg": 67,
	"./next": 68,
	"./next.jpg": 68,
	"./play": 69,
	"./play.svg": 69,
	"./tree-bot": 70,
	"./tree-bot.png": 70,
	"./tree-top": 71,
	"./tree-top.png": 71,
	"./treem-bot": 72,
	"./treem-bot.png": 72,
	"./treem-top": 73,
	"./treem-top.png": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2080;